/**
 * RECEPTION-MONEY-TRUTH-V1 (B4 / W-1, founder finding 2026-08-14): sign-out
 * on a SHARED machine must leave NO cached business data behind -- patient
 * rows, staff phones, money drafts, API tokens. THE ONE clear owner: every
 * sign-out path calls this; a second ad-hoc clear list would drift.
 *
 * WHAT IT CLEARS, AND WHY IT IS SAFE TO CLEAR ALL OF sessionStorage:
 * every sessionStorage key this app writes is per-login working state by
 * construction (the portal API token, the walk-in staff phone + form
 * secret, the clinic-context pick, the recently-viewed patient/lead strips,
 * registration drafts, intake session ids) -- none of it may outlive the
 * signed-in user on a shared front-desk machine.
 *
 * localStorage is cleared by PREFIX only: the money-desk expense drafts
 * (`money-desk-draft:*`). The Supabase auth token is supabase.auth
 * .signOut()'s own job (it removes its `sb-*` key itself); third-party keys
 * are not this app's to delete.
 */

/** The app's own localStorage prefixes holding business data. */
export const CLIENT_LOCAL_BUSINESS_PREFIXES: readonly string[] = [
  'money-desk-draft:',
];

export function clearClientSessionState(): void {
  try {
    window.sessionStorage.clear();
  } catch {
    /* storage unavailable (private mode / SSR) -- nothing cached there */
  }
  try {
    const doomed: string[] = [];
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const key = window.localStorage.key(i);
      if (
        key !== null &&
        CLIENT_LOCAL_BUSINESS_PREFIXES.some((p) => key.startsWith(p))
      ) {
        doomed.push(key);
      }
    }
    for (const key of doomed) window.localStorage.removeItem(key);
  } catch {
    /* storage unavailable -- nothing cached there */
  }
}
